import React, { Component } from "react";
import lang from '../../lang';
import PhoneLogin from '../phone-login';
import PhoneRegister from '../phone-login/phone-register';
import EmailLogin from '../email-login';
import EmailRegister from '../email-login/email-register';
import QrcodeLogin from '../qrcode-login';
import iframePop from '../../lib/popup/iframe';

import GoogleLogin  from '../thirdparty-login/google';
import WechatLogin from '../thirdparty-login/wechat';
import Transfer   from '../thirdparty-login/transfer';



class LoginPop extends Component {
	static defaultProps = {
		'cn': ['wechat', 'weibo', 'qq' ],
		'ar': ['google', 'facebook', 'twitter'],
		'all': ['google', 'facebook', 'twitter', 'line', 'wechat',  'qq',  'weibo',  ] // line
	}

	constructor(props) {
		super(props);

		this.state = {
			logging: 0,
			loginMethod: 2,

			userProcess: 'login', //用户操作流程，控制页面展示
			childProps: null

		}
	}

	componentDidMount(){
		let node = $(this.refs.tip);

		node.on('click', 'i', function(e) {
			iframePop.create({
				url: UP.Global.getH5Host() + lang.template('terms.html')
			});
		})

		node.on('click', 'em', function(e) {
			iframePop.create({
				url: UP.Global.getH5Host() + lang.template('privacy.html')
			});
		})
		let qrnode = $(this.refs.qrlogin);
		let pcnode = $(this.refs.pclogin);
		qrnode.on({
			mouseenter: function(e){
				$('.qrtip').removeClass('hidden');
			},
			mouseleave: function(e){
				$('.qrtip').addClass('hidden');
			},
		});
		pcnode.on({

			mouseenter: function(e){
				$('.pctip').removeClass('hidden');
			},
			mouseleave: function(e){
				$('.pctip').addClass('hidden');
			},
		});

		UP.Global.DA.add({
            eventName: 'loginWindowOpen',
            action: 'click'
        });

        fbq('track', 'LoginWindowOpen');

        // let thirdparty = $(this.refs.thirdparty);
        
        let el = $('.login-pop-ft');
        el.on('mouseenter','li',function(e){
			$(e.currentTarget).find('.tip').removeClass('hidden');
		}).on('mouseleave','li',function(e){
			$(e.currentTarget).find('.tip').addClass('hidden');
		})
		// let loginItem =  $('.login-form-item');
		// loginItem.on('focus','input',function(e){
		// 	$(e.currentTarget).parents('.input-wrap').addClass('purple');
		// }).on('blur','input',(e)=>{
		// 	$(e.currentTarget).parents('.input-wrap').removeClass('purple');
		// })
		$.channel.on('emailRegister',(data)=>{
			this.setState({
				logging: 0,
				userProcess: 'emailRegister',
				childProps: data,

			});
		});
		$.channel.on('emailFindPwd',(data)=>{
			this.setState({
				logging: 0,
				userProcess: 'emailFindPwd',
				childProps: data,

			},()=>{
				this.refs.emailWrap.setInitState(data);
			});
		});
		$.channel.on('emailSendSuccessTip',(data)=>{
			this.setState({
				logging: 0,
				userProcess: 'emailSendSuccess',
				childProps: data,

			},()=>{

				this.refs.emailWrap.setInitState(data);
			});
		});
		$.channel.on('emailLogin',(data)=>{
			this.setState({
				logging: 0,
				userProcess: 'emailLogin',
				childProps: data
			},()=>{
				this.refs.emailWrap.setInitState(data);
			});

		});
		$.channel.on('phoneRegister',(data)=>{
			this.setState({
				logging: 0,
				userProcess: 'phoneRegister',
				childProps: data
			},()=>{
				this.refs.phoneWrap.setInitState(data);
			});
		});
		$.channel.on('phoneFindPwd',(data)=>{
			this.setState({
				logging: 0,
				userProcess: 'phoneFindPwd',
				childProps: data
			},()=>{
				this.refs.phoneWrap.setInitState(data);
			});
		});
		$.channel.on('phoneLogin',(data)=>{
			this.setState({
				logging: 0,
				userProcess: 'phoneLogin',
				childProps: data
			});
		},()=>{
				this.refs.phoneWrap.setInitState(data);
		});
		
		

	}
	componentWillUnMount(){
		
		$.channel.off('emailLogin');
		$.channel.off('emailRegister');
		$.channel.off('emailFindPwd');
		$.channel.off('emailSendSuccessTip');
		$.channel.off('phoneRegister');
		$.channel.off('phoneFindPwd');
		$.channel.off('phoneLogin');
	}

	login(channel) {
		// this.setState({
		// 	logging: 1
		// });

		switch(channel) {
			case 'facebook':
				UP.Global.DA.add({
		            eventName: 'facebookLogin',
		            action: 'click'
		        });
				Transfer.go('fb');
				break;
			case 'twitter':
				UP.Global.DA.add({
		            eventName: 'twitterLogin',
		            action: 'click'
		        });
				Transfer.go('twitter');
				break;
			case 'wechat':
				UP.Global.DA.add({
		            eventName: 'wechatLogin',
		            action: 'click'
		        });
				WechatLogin.go();
				break;
			case 'weibo':
				UP.Global.DA.add({
		            eventName: 'weiboLogin',
		            action: 'click'
		        });
				Transfer.go('weibo');
				break;
			case 'qq':
				UP.Global.DA.add({
		            eventName: 'qqLogin',
		            action: 'click'
		        });
				Transfer.go('qq');
				break;
			case 'line':
				UP.Global.DA.add({
		            eventName: 'lineLogin',
		            action: 'click'
		        });
				Transfer.go('line');
				break;
			case 'google':
				UP.Global.DA.add({
		            eventName: 'googleLogin',
		            action: 'click'
		        });
				GoogleLogin.go();
				break;
			case 'line':
				UP.Global.DA.add({
		            eventName: 'lineLogin',
		            action: 'click'
		        });
				GoogleLogin.go();
				break;
		}
	}

	close() {
		this.props.onClose();
	}
	loginMethod(loginMethod){
		this.setState({
			loginMethod: loginMethod,
			userProcess: 'login'

		});
	}
	render() {
		let {cn, ar, all} = this.props;
		let list = all;
		let $content;
		let loginMethod = this.state.loginMethod;
		let userProcess = this.state.userProcess;

		let popTitle = '登录Uplive';
		if(userProcess == 'phoneFindPwd'){
			popTitle = '设置新密码';
		}else if(userProcess == 'emailRegister' || userProcess == 'phoneRegister'){
			popTitle = '注册账号';
		}else if(userProcess == 'emailFindPwd' || userProcess == 'emailSendSuccess'){
			popTitle = '验证邮箱';
		}
		let showThirdLogin = true;
		if(userProcess == 'emailSendSuccess'){
			showThirdLogin = false;
		}


		switch (UP.Global.version)  {
			case 'CN':
				list = cn;
				break;
			case 'AR':
				list = ar;
				break;
			default: 
				list = all;

		}
		
		if (UP.Global.ie10AndOlder()) {

	        if (list.indexOf('google') > -1) {
	            list.splice(list.indexOf('google'), 1);
			}

			if (list.indexOf('wechat') > -1) {
	            list.splice(list.indexOf('wechat'), 1);
			}
		}


		if (this.state.logging == 1) {
			$content = (
				<div className="login-pop-loading">
					{ lang.template('正在登录')}
				</div>
			);
		} else {

			if(userProcess == 'emailRegister' || userProcess == 'emailFindPwd' || userProcess == 'emailFindPwd' || userProcess == 'emailLogin' || userProcess == 'emailSendSuccess'){

				$content =(<EmailRegister childProps={this.state.childProps} ref="emailWrap"/>);
			}else if(userProcess == 'phoneRegister' || userProcess == 'phoneFindPwd' || userProcess == 'phoneLogin' ){

				$content =(<PhoneRegister childProps={this.state.childProps} ref="phoneWrap"/>);
			}else{

				if(loginMethod == 1){
					$content = (
						<div className="login-pop-content clearfix">
							<div className="login-pop-content-box">
								<QrcodeLogin/>
							</div>
						</div>
					);
				}else {
					$content = (
						<div className="email-phone-login-box">
							<div className="login-tabs">
								<div className={`tab tel ${loginMethod == 2 ? "selected" : ''}`} onClick={this.loginMethod.bind(this,2)} >{lang.template('手机注册/登录')}</div>
								<div className={`tab email ${loginMethod != 2 ? "selected" : ''}`} onClick={this.loginMethod.bind(this,3)} >{lang.template('邮箱注册/登录')}</div>
							</div>
							{
								loginMethod == 2 ? (
									<PhoneLogin/>
								):(
									<EmailLogin/>
								)
							}
						</div>
					);
				}
			}
		}
		

		return (
			<div className="login-pop">
				<div className={` ${showThirdLogin?'box':'no-third-box box'}`}>
					<div className="login-pop-hd">
						<span className="l-tip">{lang.template(popTitle)}</span>

						<span className={`l-qr ${loginMethod == 1 ? 'selected' : ''}`} onClick={this.loginMethod.bind(this,1)} ref="qrlogin">
							<em className="tabtip qrtip hidden">{lang.template('扫码登录')}</em>
						</span>
						<span className="split"></span>
						<span className={`l-pc ${loginMethod != 1 ? 'selected' : ''}`} onClick={this.loginMethod.bind(this,2)} ref="pclogin">	
							<em className="tabtip pctip hidden">{lang.template('密码登录')}</em>
						</span>
						<span className="close" onClick={()=>this.close()}>x</span>
						
						
					</div>
					{ $content }
					{
						showThirdLogin ? (
							<div className="login-pop-ft">
								<h3>{lang.template('其他登录方式')}</h3>
								<ul ref="thirdparty">
								{
									list.map((channel, index)=>{
										return (
											<li key={index} className={channel} onClick={()=>this.login(channel)} >
												<i></i>
												<em className="tip hidden">{channel}</em>

											</li>
										)
									})
								}
								</ul>
							</div>
							
						):null
					}
					<div className="login-pop-tip">
						<div className="notice middlebefore">
							<span className="tip"  ref="tip" dangerouslySetInnerHTML={{ __html: lang.template("登录代表你接受Up直播《服务条款及隐私政策》") }}></span>
						</div>
					</div>

				</div>
			</div>
		);
	}
}

export default LoginPop;


// WEBPACK FOOTER //
// ./js/component/login-pop/index.js